import { ProjectFileType } from '@common/project-files/enums/project-file-type.enum';
import { extname } from '@common/util/path';
import { WorkspaceFileType } from '@common/workspace/enums/workspace-file-type.enum';

export function getFileType(filePath: string): ProjectFileType {
  switch (getFileExtension(filePath).toLowerCase()) {
    case '.bmp':
    case '.gif':
    case '.jpeg':
    case '.jpg':
    case '.png':
    case '.tif':
    case '.tiff':
      return ProjectFileType.Image;
    case '.flmsp':
    case '.flsnp':
    case '.htm':
    case '.html':
      return ProjectFileType.Flare;
    case '.flcts':
      return ProjectFileType.ConditionTagSet;
    case '.flvar':
      return ProjectFileType.VariableSet;
    case '.fltar':
      return ProjectFileType.Target;
    case '.css':
      return ProjectFileType.Stylesheet;
    case '.pdf':
    case '.swf':
    case '.wmv':
    case '.docx':
    case '.xlsx':
    case '.ttf':
    case '.zip':
    case '.mp3':
    case '.mpg':
    case '.webm':
    case '.hdp':
    case '.eps':
    case '.wdp':
    case '.emf':
    case '.xps':
    case '.cur':
    case '.dib':
    case '.exps':
    case '.wmf':
    case '.u3d':
    case '.webp':
    case '.flv':
    case '.mov':
    case '.mp4':
    case '.avi':
    case '.wma':
    case '.qt':
    case '.oga':
    case '.ogg':
    case '.ogv':
    case '.spx':
    case '.mpe':
    case '.jpe':
    case '.doc':
    case '.xls':
    case '.idml':
    case '.ppt':
    case '.pptx':
    case '.flprjzip':
    case '.exe':
    case '.chm':
    case '.d2h':
    case '.book':
    case '.fm':
    case '.lirev':
    case '.fltrev':
    case '.mcco':
    case '.mccot':
    case '.mcdoc':
    case '.mcdoct':
    case '.fprjzip':
    case '.asx':
    case '.asf':
    case '.au':
    case '.m4v':
    case '.mid':
    case '.midi':
    case '.mpa':
    case '.mpeg':
    case '.opus':
    case '.wav':
      return ProjectFileType.Binary;
    default:
      return ProjectFileType.Code;
  }
}

export function getWorkspaceFileType(filePath: string): WorkspaceFileType {
  switch (getFileExtension(filePath).toLowerCase()) {
    case '.htm':
    case '.html':
      return WorkspaceFileType.Topic;
    case '.flmsp':
      return WorkspaceFileType.TemplatePage;
    case '.flsnp':
      return WorkspaceFileType.Snippet;
    default:
      return WorkspaceFileType.Code;
  }
}



export function getFileExtension(filePath: string): string {
  return extname(filePath);
}

